import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';

import { FeatureFlags } from '@data/constants';
import { FeatureFlagsProvider } from '@shared/providers';

export const isOfflineGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): boolean | UrlTree => {
  const featureFlagsProvider = inject(FeatureFlagsProvider);
  const router = inject(Router);

  const isAppOffline = featureFlagsProvider.getFlag(FeatureFlags.IS_OFFLINE);
  const isTargetingOfflineRoute = route.routeConfig?.path === 'offline';

  if (isAppOffline && !isTargetingOfflineRoute) {
    return router.createUrlTree(['/offline']);
  }

  if (!isAppOffline && isTargetingOfflineRoute) {
    return router.createUrlTree(['/public']);
  }

  return true;
};
